interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  return (
    <div className="flex items-center justify-center gap-2">
      <button
        className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 text-foreground-600 hover:bg-background-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <button
          key={page}
          className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors cursor-pointer ${
            page === currentPage
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-200 text-foreground-600 hover:bg-background-100'
          }`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}
      <button
        className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 text-foreground-600 hover:bg-background-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}